'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'

interface LandingShellProps {
  children: React.ReactNode
  theme?: 'vanmoose' | 'thumbgrab' | 'nameforge' | 'webwatch' | 'facturix' | 'postoko' | 'tenscore' | 'checkcheck' | 'repetix' | 'tracktron' | 'mothership' | 'burstlet' | 'truncus' | 'outflank' | 'protagon' | 'centralcommand' | 'coldcopy' | 'crewcontrol'
}

export function LandingShell({
  children,
  theme = 'vanmoose'
}: LandingShellProps) {
  return (
    <div
      data-theme={theme}
      className={cn(
        'min-h-screen bg-[var(--landing-bg)] text-[var(--landing-text-primary)]',
        'antialiased'
      )}
    >
      {children}
    </div>
  )
}
